import PropTypes from 'prop-types';
import { CloseButton } from 'components/UI/CloseButton/CloseButton';
import { BookingModalBreadcrumb } from '../BookingModalBreadcrumb/BookingModalBreadcrumb';
import './BookingModalHeader.scss';

export const BookingModalHeader = (props) => {
  const { heading, closeModalHandler } = props;

  return (
    <div className="booking-modal__header" data-testid="modal-header">
      <CloseButton
        text="Close"
        extendClass="booking-modal__close-btn"
        onClick={closeModalHandler}
      />
      <div className="spire-bg bg-top-right">&nbsp;</div>
      <p>Booking tickets to</p>
      <h1 className="booking-modal__title h2" data-testid="heading">
        {heading}
      </h1>
      <BookingModalBreadcrumb />
    </div>
  );
};

BookingModalHeader.propTypes = {
  heading: PropTypes.string,
  closeModalHandler: PropTypes.func,
};
